import { defineMessages } from 'react-intl';

export const mcpLegalDisclaimerMessages = defineMessages({
  agreementHeader: {
    id: 'oauth.mcp.bestPracticesHeader',
    defaultMessage: "By accepting, you agree to {product}'s ",
    description:
      'Header for the legal disclaimer agreement list; {product} is dynamic based on what is passed in',
  },
  agreementBulletTwo: {
    id: 'oauth.mcp.bestPracticesBulletTwo',
    defaultMessage: '{privacyPolicyLink} and {termsOfUseLink}.',
    description:
      'Legal disclaimer bullet about privacy policy and terms of use',
  },
  forgeAgreementLinks: {
    id: 'oauth.mcp.forge.agreementLinks',
    defaultMessage:
      "{privacyPolicyLink} and {termsOfUseLink} for the MCP Server, and {hasVendor, select, true {{vendorName}'s} other {the applicable developer's}} {appPrivacyPolicyLink} and terms of use for {appName}.",
    description:
      'Forge MCP legal disclaimer, following the agreement header. {vendorName} is the app developer (falls back to "the applicable developer" when unset) and {appName} is the Forge app. {privacyPolicyLink} / {appPrivacyPolicyLink} render as "privacy policy" links and {termsOfUseLink} as a "terms of use" link.',
  },
  mcpServerAddedAgreementBulletTwo: {
    id: 'oauth.mcp.agentAgrrementBulletTwo',
    defaultMessage:
      '{privacyPolicyLink} and {termsOfUseLink} for use of the MCP Server.',
    description:
      'Legal disclaimer bullet about privacy policy and terms of use',
  },
  privacyPolicy: {
    id: 'oauth.mcp.privacyPolicy',
    defaultMessage: 'privacy policy',
    description: 'Link text for the privacy policy',
  },
  termsOfUse: {
    id: 'oauth.mcp.termsOfUse',
    defaultMessage: 'terms of use',
    description: 'Link text for the terms of use',
  },
});
